// export default StudentPage
import React, { useState, useEffect } from "react";
import Layout from "partials/layout";
import { ERCText } from "components/text";
import EventsCard from "components/eventscard";
import CourseCard from "components/studentcoursecard";
import CounsellorChatCard from "components/counsellorchatcard";
// import art from "assets/images/arts.svg";
// import commercial from "assets/images/commercial.svg";
// import sciences from "assets/images/sciences.svg";
import { PaginationSection } from "components/pagination/newPagination";
import { EventServices } from "services/event";
import { CourseServices } from "services/courses";

const StudentPage = ({ btnFunction = () => null }) => {
  const [allEvent, setAllEvents] = useState([])
  const [studentDetails, setStudentDetails] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setLoading]= useState(false)
  useEffect(() => {
    getAllEvents();
  }, []);
  
  const getAllEvents = async () => {
    setLoading(true);
    try {
      const response = await EventServices.fetchEvents();
      // console.log("fetch event", response);
      if (response.data.status === 'success') {
        const res = response.data.data.details;
        setAllEvents(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
//   const upcomingEvents = allEvent
//   .filter((event) => new Date(event.date) > Date.now())
//   .sort((a, b) => new Date(a.date) - new Date(b.date))
//   .slice(0, 3);

// // If there are no upcoming events, get the latest past three events
// if (upcomingEvents.length === 0) {
//   upcomingEvents = allEvent
//     .filter((event) => new Date(event.date) <= Date.now())
//     .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort in descending order
//     .slice(0, 3);
// }


const [upcomingEvents, setUpcomingEvents] = useState([]);

useEffect(() => {
  if (!allEvent.length) return; // Prevent running on empty data

  let events = allEvent
    .filter((event) => new Date(event.date) > Date.now())
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, 3);

  if (events.length === 0) {
    events = allEvent
      .filter((event) => new Date(event.date) <= Date.now())
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .slice(0, 3);
  }

  setUpcomingEvents(events);
}, [allEvent]); // Runs when allEvent updates



console.log("Filtered and sorted upcoming events:", upcomingEvents);
  const img = [
    {
      id: 1,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718324097/tourlagosimg_ryg3m5.svg",
    },
    {
      id: 2,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718324097/tourlagosimg_ryg3m5.svg",
    },
    {
      id: 3,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718324097/tourlagosimg_ryg3m5.svg",
    },
  ];



  useEffect(() => {
    getAllStudentsCourse();
  }, []);

  const getAllStudentsCourse = async () => {
    try {
      const response = await CourseServices.fetchStudentCourses();
      console.log("fetch courses", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        setStudentDetails(res?.rows);
      }
    } catch (error) {
      console.log(error);
    }
  };


  // Read more
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const fullText = `Discover the vibrant pulse of Lagos, Nigeria’s cultural and economic hub, on this captivating day tour. Begin your adventure at the historic Tafawa Balewa Square, a monument to Nigeria’s rich history. Continue to the bustling Lagos Island markets, where you’ll experience the energetic blend of sights and sounds. Explore the serene Lekki Conservation Centre, walking along the iconic canopy walkway. Visit Nike Art Gallery to marvel at local masterpieces, and experience the vibrant nightlife at Freedom Park. Along the way, indulge in traditional Nigerian dishes like jollof rice and suya, completing your day with a sunset view over the Third Mainland Bridge. This tour offers a dynamic blend of history, nature, and culture`;

  // status change
  const [courseStatus, setCourseStatus] = useState("All Courses");
  const statuses = [
    "All Courses",
    "Featured",
    "Music",
    "Humanities",
    "Language",
    "Sciences",
    "Arts & Hummanities",
    "Business",
    "Accounting",
  ];
  // pagination section
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentTableData = studentDetails?.slice(firstPostIndex, lastPostIndex);
  // Calculate total pages
  const totalPosts = studentDetails?.length;
  // Function to handle changing pages
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const filteredCourses =
    courseStatus === "All Courses"
      ? currentTableData
      : currentTableData.filter(
          (course) => course.subCategory === courseStatus
        );

  // const handleNext = () => {
  //   setActiveIndex((prevIndex) => (prevIndex + 1) % eventData.length);
  // };

  // const handlePrev = () => {
  //   setActiveIndex(
  //     (prevIndex) => (prevIndex - 1 + eventData.length) % eventData.length
  //   );
  // };
  // Event slide
  const [activeIndex, setActiveIndex] = useState(0);

  const goToSlide = (index) => {
    setActiveIndex(index);
  };

  // image slide
  const [activeImage, setActiveImage] = useState(0);

  const goToSlideImage = (index) => {
    setActiveImage(index);
  };
  const handleViewClick = (id) => {
    const selectedCourse = studentDetails.find((course) => course.id === id);
    localStorage.setItem("#enrolcourse", JSON.stringify(selectedCourse.id));
    console.log("View enrol course Detail", selectedCourse.id);
    // console.log("enroll")
  };
  return (
    <Layout mqcolor="#00296B">
      <div className="bg-white w-full flex flex-col items-center">
        <div className="w-full bg-cover bg-center h-96">
          <img
            src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721917861/ERC/Frame_1000002097_frafjo.svg"
            alt="Header"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Events Section */}
        <div className="w-full py-16 px-6 md:px-24 lg:px-24">
          <div className="mb-8 w-fit">
            <ERCText color="#00296B" weight="700" size="14px">
              EVENTS
            </ERCText>
            <hr className="border-t-2 border-yellow-500 w-full" />
          </div>
          <div className="mb-8">
            <ERCText size="40px" weight="700">
              Upcoming Events
            </ERCText>
          </div>

          <div className=" w-full">
            {/* Carousel Content */}
            <div className="overflow-hidden w-full">
              <div
                className="w-full flex transition-transform duration-500"
                style={{ transform: `translateX(-${activeIndex * 100}%)` }}
              >
                {upcomingEvents
                  .map((event, index) => (
                    <div key={index} className="w-full flex-shrink-0">
                      <EventsCard {...event} />
                    </div>
                  ))}
              </div>
            </div>

            {/* Navigation Arrows */}
            {/* <button onClick={handlePrev} className="absolute left-2 top-1/2 transform -translate-y-1/2 text-3xl">
        &#8592; 
      </button>
      <button onClick={handleNext} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-3xl">
        &#8594; 
      </button> */}

            {/* Pagination Dots */}
            <div className="flex justify-center mt-6">
              {upcomingEvents
                .map((_, index) => (
                  <div
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-8 h-2 rounded-full mx-2 transition-all cursor-pointer ${
                      index === activeIndex ? "px-6 bg-primary " : "bg-gray-300"
                    }`}
                  ></div>
                ))}
            </div>
          </div>
        </div>

        {/* Courses Section */}
        <div className="w-full py-16 px-6 md:px-24 lg:px-24">
          <div className="flex overflow-x-auto scrollbar-hide justify-center gap-4 mb-8">
            {statuses.map((course) => (
              <button
                onClick={() => setCourseStatus(course)}
                className={`md:text-[16px] transition-all hover:bg-primary font-ManropeSemibold md:leading-[24px] rounded-sm px-4 py-2 ${
                  courseStatus === course
                    ? "bg-primary text-secondary "
                    : "text-secondary border-[1px] border-primary "
                }`}
              >
                {course}
              </button>
            ))}
          </div>

          <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCourses.map((course, index) => (
              <CourseCard key={index} {...course} handleViewClick={handleViewClick} />
            ))}
          </div>
          <div className="w-full  ">
            <PaginationSection
              totalPosts={totalPosts}
              postsPerPage={postsPerPage}
              currentPage={currentPage}
              setCurrentPage={handlePageChange}
            />
          </div>
        </div>

        {/* Tour Lagos Section */}
        <div
          className="w-full bg-cover bg-center py-20 px-6 md:px-20 lg:px-32 bg-no-repeat"
          style={{
            backgroundImage: `url('https://res.cloudinary.com/dmrtylvtc/image/upload/v1718283193/tourlagos_bg_jwbcmi.svg')`,
          }}
        >
          <div className="flex flex-col gap-10">
            <div>
              <ERCText color="#00296B" size="14px" weight="700" lHeight="20px">
                ARTS & CULTURE IN LAGOS
              </ERCText>
              <hr className="border-t-2 border-yellow-500 w-20" />
            </div>
            <div className="flx flex-col gap-6">
              <ERCText size="32px" weight="700" lHeight="40px">
                Tour Lagos - A Place Of No Return In Badagry
              </ERCText>
              <ERCText
                size="16px"
                lHeight="24px"
                weight="400"
                className="text-justify mt-4 transition-all"
              >
                {isExpanded ? fullText : `${fullText.slice(0, 300)}...`}{" "}
                <button
                  onClick={handleToggle}
                  className="text-blue-500 hover:underline ml-2"
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              </ERCText>
            </div>
            <div className="overflow-hidden w-full ">
              <div
                className=" flex gap-6 transition-transform duration-500"
                style={{ transform: `translateX(-${activeImage * 100}%)` }}
              >
                {img.map((item, index) => (
                  <div key={index} className=" flex-shrink-0">
                    <img src={item.img} alt={`tour ${item.id}`} />
                  </div>
                ))}
              </div>
            </div>
            {/* Pagination Dots */}
            <div className="flex justify-center mt-6">
              {img.map((_, index) => (
                <div
                  key={index}
                  onClick={() => goToSlideImage(index)}
                  className={`w-8 h-2 rounded-full mx-2 transition-all cursor-pointer ${
                    index === activeImage ? "px-6 bg-secondary " : "bg-gray-300"
                  }`}
                ></div>
              ))}
            </div>
          </div>
        </div>

        {/* Counsellor Chat Card */}
        <div className="w-full bg-gray-100 py-16  flex justify-center items-center">
          <CounsellorChatCard />
        </div>
      </div>
    </Layout>
  );
};

export default StudentPage;